import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { initClaims } from './initClaims';

const AuthInitializer = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        void initClaims(dispatch);
    }, [dispatch]);
    return null;
};

export default AuthInitializer;
